export enum ForecastingRoutePathNames {
  SHEET = '',
  FORECASTING = 'forecasting',
}
